import axios from 'axios'
import { router } from '@/router'
const LOGIN_URL = process.env.API_URL + 'token'
import * as Msal from "msal";

export default {

  msalInstance: null,
  user: {
    authenticated: false
  },
  pageredirect: '',

  login() {
    // Clear session to remove "login in process" error
    this.logout()

    var msalConfig = {
      auth: {
        clientId: '63f4f91b-0710-4915-bd8b-a0209ce73d1b',
        authority: "https://login.microsoftonline.com/gentekconsultationcom.onmicrosoft.com"
      },
      // system: {
      //   logger: logger,
      //   tokenRenewalOffsetSeconds: 1200
      // }
    }
    this.msalInstance = new Msal.UserAgentApplication(msalConfig)
    var loginRequest = {
      scopes: ["user.read", "mail.send"] // optional Array<string>
    };


    this.msalInstance.loginPopup(loginRequest)
      .then(response => {
        //Login Success
        this.postLoginProcess(response.idToken.rawIdToken)
        setInterval(() => this.renewToken(loginRequest), 3600000)

        //FIX: Does not load API Index constructor on router.replace ??? To investigate...
        axios.create({ baseURL: process.env.API_URL }).defaults.headers.common['Authorization'] = this.getAuthHeader()
        router.replace("accueil")
      })
      .catch(error => {
        console.log(error.response)
      })
  },

  renewToken(loginRequest) {
    console.log("renewToken")
    var self = this
    this.msalInstance.acquireTokenSilent(loginRequest).then(function (response) {
      //AcquireTokenSilent Success
      self.postLoginProcess(response.idToken.rawIdToken)
    }, function (error) {
      console.log(error);
    })
      .catch(error => {
        console.log(error.response)
      })
  },

  postLoginProcess(token) {
    localStorage.setItem('id_token', token)
    this.user.authenticated = true
  },

  logout() {
    localStorage.removeItem('id_token')
    sessionStorage.clear();
    this.user.authenticated = false
    if (this.msalInstance != null) {
      this.msalInstance.logout()
      this.msalInstance = null
    }
  },

  checkAuth() {
    var jwt = localStorage.getItem('id_token')
    if (jwt) {
      this.user.authenticated = true
    }
    else {
      this.user.authenticated = false
    }
  },

  isUserAuthenticated() {
    return this.user.authenticated;
  },

  getAuthHeader() {
    return 'Bearer ' + localStorage.getItem('id_token')
  }
}



// WEBPACK FOOTER //
// ./src/auth/index.js